import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMovieContext } from '../context/MovieContext';
import './Hero.css';

function Hero() {
  const { movies, handleSelectMovie, addToWatchLater } = useMovieContext();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (movies.length === 0) return;

    const intervalId = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % movies.length);
    }, 30000); // 30 seconds

    return () => clearInterval(intervalId);
  }, [movies]);

  const latestMovie = movies.length > 0 ? movies[currentIndex] : null;
  const backgroundImageUrl = latestMovie ? `https://image.tmdb.org/t/p/original/${latestMovie.backdrop_path}` : '';

  const trimOverview = (overview, maxLength) => {
    if (!overview) return '';
    if (overview.length <= maxLength) return overview;
    return overview.substring(0, maxLength) + '...';
  };

  const handleWatchClick = (movieId) => {
    handleSelectMovie(movieId);
  };

  const handleAddToWatchLaterClick = (movie) => {
    addToWatchLater(movie);
  };

  return (
    <div className="hero-section" style={{ backgroundImage: `url(${backgroundImageUrl})` }}>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">{latestMovie ? latestMovie.title : ''}</h1>
        <p className="hero-description">{latestMovie ? trimOverview(latestMovie.overview, 150) : ''}</p>

        <div className='button-container'>
          {latestMovie && (
            <>
              <Link to={`/watch/${latestMovie.id}`} className='btn btn-watch' onClick={() => handleWatchClick(latestMovie.id)}>
                <i className="fas fa-play"></i> Watch Now
              </Link>
              <button className='btn btn-list' onClick={() => handleAddToWatchLaterClick(latestMovie)}>
                <i className="fas fa-plus"></i> Add to Watch Later
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Hero;
